export default __webpack_public_path__ + "assets/fd6e22.svg";